import number from '@/filters/number';

const EMPTY = '-';

export function calculateImc(data = {}) {
  const { height, weight } = data;

  if (!height || !weight) {
    return 0;
  }

  const result = (weight / (height * height)) * 10000;

  return result < 14 || result > 55 ? 0 : result;
}

export function anthropometry(data = {}) {
  const imc = calculateImc(data);

  return [
    { label: 'Altura', value: data.height ? `${data.height} cm` : EMPTY },
    { label: 'Peso', value: data.weight ? `${data.weight} kg` : EMPTY },
    { label: 'IMC', value: imc ? `${number(imc, 2)} kg/m²` : EMPTY },
    {
      label: 'Per. cefálico',
      value: data.cephalicPerimeter ? `${data.cephalicPerimeter} cm` : EMPTY,
    },
    {
      label: 'C. abdominal',
      value: data.abdominalCircumference ? `${data.abdominalCircumference} cm` : EMPTY,
    },
  ];
}

export function vitalSigns(data = {}) {
  return [
    {
      label: 'Pressão arterial',
      value: data.bloodPressure ? `${data.bloodPressure} mm/Hg` : EMPTY,
    },
    { label: 'Freq. cardíaca', value: data.heartRate ? `${data.heartRate} bpm` : EMPTY },
    {
      label: 'Freq. respiratória',
      value: data.respiratoryFrequency ? `${data.respiratoryFrequency} mpm` : EMPTY,
    },
    { label: 'Temperatura', value: data.temperature ? `${data.temperature} ºC` : EMPTY },
    { label: 'Saturação O²', value: data.saturation ? `${number(data.saturation, 0)}%` : EMPTY },
  ];
}

export function filled(measures) {
  return measures.filter(({ value }) => value !== EMPTY);
}
